// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","albumImage":"Card_albumImage__qNH6h","topic":"Card_topic__VqVlB","media":"Card_media__fciMr","actions":"Card_actions__Begb1","chip":"Card_chip__agKFm"};